import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { RegionService } from "@edp-services/region.service";
import { regionElementsHidden } from "@edp-utils/region-components-hidden.utils";

@Directive({
    selector: "[edpConditionalRegion]",
})
export class ConditionalRegionDirective {
    private region: string;

    constructor(
        private readonly templateRef: TemplateRef<any>,
        private readonly viewContainer: ViewContainerRef,
        private readonly regionService: RegionService
    ) {
        this.region = this.regionService.getRegion();
    }

    private showByRegion(elementKey: string): boolean {
        if (regionElementsHidden[elementKey]) {
            return !regionElementsHidden[elementKey].includes(this.region);
        }
        return true;
    }

    private renderView(elementKey: string): void {
        if (this.showByRegion(elementKey)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }

        this.viewContainer.clear();
    }

    @Input() set edpConditionalRegion(elementKey: string) {
        this.renderView(elementKey);
    }
}
